import { Group, Stack, Text } from "@mantine/core";
import { distanceFromMe } from "helpers/location";
import { getDataSourcePillText } from "helpers/practitioner";
import { FC, useEffect, useState } from "react";

interface Props {
  practitioner: any;
  index: number;
  onClick: () => void;
};

const ListItem: FC<Props> = ({ index, practitioner, onClick }) => {
  const [distance, setDistance] = useState<number | null>(null);
  const dataSourcePillText = getDataSourcePillText(practitioner);

  useEffect(() => {
    const a = practitioner?.addresses[0];
    distanceFromMe(a?.latitude, a?.longitude)
      .then((distance) => {
        setDistance(distance);
      })
  }, [practitioner?.addresses]);

  return (
    <Stack gap={0} py={15}
      style={{
        borderBottom: "1px solid #F0F0F0"
      }}
      onClick={() => onClick()}>
      <Group justify="space-between" align="center">
        <Text fz={20} fw="bold" truncate="end" maw="80%">
          {index}. {practitioner?.primary_name}
        </Text>
        {dataSourcePillText && (
          <Text 
            bg="#e53e3e" c="white" fz="0.8rem" 
            fw="500" p="2px 5px" bdrs="8px">
            {dataSourcePillText}
          </Text>
        )}
      </Group>
      <Group justify="space-between" align="center">
        <Text fz={14} c="#8B8B8B" truncate="end" maw="80%">
          {practitioner?.addresses[0]?.address}
        </Text>
        <Text fz={14} fw="bold" c="#4F7D9C">
          {distance} m
        </Text>
      </Group>
    </Stack>
  );
};

export default ListItem;